import { PrognosisDb } from "../types/Prognosis";
import Dexie from 'dexie';
import { CardOfTheDayDb } from '../types/Card';
import { iso8601ToDate } from "../utils/iso8601ToDate";

const ASTRO_PROGNOSIS_TABLE = 'astroPrognosis';
const ZODIAC_PROGNOSIS_TABLE = 'zodiacsPrognosis';
const LOCAL_YEAR_PROGNOSIS_KEY = 'localYearPrognosis';
const LOCAL_CARD_OF_THE_DAY_KEY = 'localCardOfTheDay';

interface PrognosisDao {
    getAllAstroPrognosis: () => Promise<PrognosisDb[]>;
    saveAllAstroPrognosis: (prognosis: PrognosisDb[]) => void;
    clearAllAstroPrognosis: () => void;
    getAllZodiacPrognosis: () => Promise<PrognosisDb[]>;
    saveAllZodiacPrognosis: (prognosis: PrognosisDb[]) => void;
    clearAllZodiacPrognosis: () => void;
    getYearPrognosis: () => PrognosisDb | null;
    saveYearPrognosis: (prognosis: PrognosisDb) => void;
    clearYearPrognosis: () => void;
    clearAllPrognosis: () => void;
    getCardOfTheDay: () => CardOfTheDayDb | null;
    saveCardOfTheDay: (cardOfTheDay: CardOfTheDayDb) => void;
    clearCardOfTheDay: () => void;
}

class PrognosisDatabase extends Dexie {
    astroPrognosis: Dexie.Table<PrognosisDb, string>;
    zodiacsPrognosis: Dexie.Table<PrognosisDb, string>;
    constructor() {
      super('HoroscopeDatabase');
      
      this.version(1).stores({
        [ASTRO_PROGNOSIS_TABLE]: 'objectId, startDate, endDate, text',
        [ZODIAC_PROGNOSIS_TABLE]: 'objectId, startDate, endDate, text',
      });
      
      this.astroPrognosis = this.table(ASTRO_PROGNOSIS_TABLE);
      this.zodiacsPrognosis = this.table(ZODIAC_PROGNOSIS_TABLE);
    }
  }

const db = new PrognosisDatabase();

const prognosisDao: PrognosisDao = {
    
    getAllAstroPrognosis: async () => {
        return await db.astroPrognosis.toArray().then(prognosis => prognosis.sort((a, b) => (iso8601ToDate(b.endDate ?? "")?.getTime() ?? 0) - (iso8601ToDate(a.endDate ?? "")?.getTime() ?? 0)));
    },

    saveAllAstroPrognosis: async (prognosis: PrognosisDb[]) => {
        await db.astroPrognosis.bulkPut(prognosis);
    },
    clearAllAstroPrognosis: async () => {
        await db.astroPrognosis.clear();
    },

    getAllZodiacPrognosis: async () => {
        return await db.zodiacsPrognosis.toArray().then(prognosis => prognosis.sort((a, b) => (iso8601ToDate(b.endDate ?? "")?.getTime() ?? 0) - (iso8601ToDate(a.endDate ?? "")?.getTime() ?? 0)));
    },
    saveAllZodiacPrognosis: async (prognosis: PrognosisDb[]) => {
        await db.zodiacsPrognosis.bulkPut(prognosis);
    },
    clearAllZodiacPrognosis: async () => {
        await db.zodiacsPrognosis.clear();
    },

    getYearPrognosis: () => {
        const prognosis = localStorage.getItem(LOCAL_YEAR_PROGNOSIS_KEY);
        return prognosis ? JSON.parse(prognosis) : null;
    },
    saveYearPrognosis: (prognosis: PrognosisDb) => {
        localStorage.setItem(LOCAL_YEAR_PROGNOSIS_KEY, JSON.stringify(prognosis));
    },

    getCardOfTheDay: () => {
        const cardOfTheDay = localStorage.getItem(LOCAL_CARD_OF_THE_DAY_KEY);
        return cardOfTheDay ? JSON.parse(cardOfTheDay) : null;
    },
    saveCardOfTheDay: (cardOfTheDay: CardOfTheDayDb) => {
        localStorage.setItem(LOCAL_CARD_OF_THE_DAY_KEY, JSON.stringify(cardOfTheDay));
    },
    clearCardOfTheDay: () => {
        localStorage.removeItem(LOCAL_CARD_OF_THE_DAY_KEY);
    },

    clearYearPrognosis: () => {
        localStorage.removeItem(LOCAL_YEAR_PROGNOSIS_KEY);
    },

    clearAllPrognosis: () => {
        prognosisDao.clearCardOfTheDay();
        prognosisDao.clearAllAstroPrognosis();
        prognosisDao.clearAllZodiacPrognosis();
        prognosisDao.clearYearPrognosis();
    },
}

export default prognosisDao;
